// extracted by mini-css-extract-plugin
module.exports = {"withIcon":"TimeInput_withIcon__AdtDs","clockIcon":"TimeInput_clockIcon__2VPdv"};